/**
 * Enum for data loading that is triggered after a user action.
 */
enum LoadingStatus {
	NOT_LOADED,
	LOADING,
	LOADED,
}

export default LoadingStatus;
